// extracted by mini-css-extract-plugin
export default {"loginPage":"login__loginPage","header":"login__header","title":"login__title","description":"login__description"};